<template>
    <div class="tasks-list" :class="{loading: loading}">
        <div class="row">
            <div class="col-sm-6 col-md-5 form-group align-sm-left">
                <button type="button" class="btn btn-success" @click="openTask(null)">
                    Create Admin Ticket
                </button>
            </div>
        </div>
        <fieldset>
            <legend v-if="taskableEmail">Zendesk Tickets</legend>
            <span v-if="!taskableEmail" />
            <div v-else-if="zendeskTickets.length === 0 && !loading">
                No relevant zendesk tickets found
            </div>
            <div v-else-if="!loading">
                <div v-for="(zTicket, zIndex) in zendeskTickets" :key="zTicket.id" class="list-group">
                    <a :href="zTicket.ticketUrl" class="list-group-item link" target="_blank">
                        <p>
                            Ticket Number: <b>{{ '#' + zTicket.id }}</b><br>
                            Subject: <b>{{ zTicket.subject ? zTicket.subject : '-' }}</b><br>
                            Channel: {{ zTicket.channel ? zTicket.channel : '-' }}<br>
                            Type: {{ zTicket.ticketType ? zTicket.ticketType : '-' }}<br>
                            Status: {{ zTicket.status ? zTicket.status : '-' }}<br>
                            Created: {{ zTicket.createdAt ? zTicket.createdAt : '-' }}
                        </p>
                    </a>
                </div>
            </div>

            <legend>
                <div class="row">
                    <div class="col-sm-6 col-md-7 text-right form-group pull-sm-right">
                        Tickets
                    </div>
                </div>
            </legend>

            <div class="list-group">
                <a href="javascript://void(0)" class="list-group-item link"
                   v-for="task in tasks"
                   @click="openTask(task.id)">
                    <h4>{{task.title}}</h4>
                    <h5>
                        Ticket {{task.display_id}} <span v-html="task.statusLabel"></span>
                    </h5>
                </a>
            </div>
        </fieldset>

        <task ref="task" :task-id="taskId" :afterSave="loadTasks"
              :defaults="{ task: { 'taskable_type': taskableType, 'taskable_id': taskableId, 'taskable_type_name': taskableTypeName, 'taskable_name': taskableName } }">
            <span></span>
        </task>
    </div>
</template>

<script>
    export default {
        props: {
            taskableId: {
                required: true,
                type: String
            },

            taskableType: {
                required: true,
                type: String
            },

            taskableTypeName: {
                type: String
            },

            taskableName: {
                type: String
            },

            taskableEmail: {
                type: String
            },

            taskablePhone: {
                type: String
            }
        },

        data: function(){
            return {
                loading: true,
                tasks: [],
                taskId: null,
                zendeskTickets: []
            };
        },

        mounted: function(){
            var self = this;

            Promise.all( [
                this.loadTasks(),
                this.loadZendeskTickets()
            ] )
                .then( function(){
                    self.loading = false;
                } );
        },

        methods: {
            loadTasks: function(){
                var self = this;
                var url = '/api/tasks/list?taskable_id=' + this.taskableId + '&taskable_type=' + this.taskableType;

                return axios.get( url )
                    .then( function( response ){
                        self.$set( self, 'tasks', response.data.data );
                    } );
            },

            loadZendeskTickets: function() {
                if (this.taskableEmail || this.taskablePhone) {
                    var self = this;
                    var email = this.taskableEmail.replaceAll('+', '%2B');
                    email = email.replaceAll(" ", "");
                    var phone = this.taskablePhone.replaceAll('+', '%2B');
                    phone = phone.replaceAll(" ", "");
                    var url = '/api/tasks/zendesk?email=' + email + '&phone=' + phone;

                    return axios.get( url )
                        .then(function(response) {
                            self.$set(self, 'zendeskTickets', response.data);
                        });
                }
            },

            openTask: function( taskId ){
                var self = this;
                this.taskId = taskId;

                this.$nextTick( function(){
                    self.$refs.task.openModal();
                } );
            },

            getFormattedTime(date) {
                if (!date) {
                    return '-'
                }
                var formattedDate = new Date(date);
                return formattedDate.toLocaleTimeString();
            }
        }
    }
</script>
